var __rspack_ns_object = JSON.parse('{"confirmationDialog":{"title":"ARE YOU SURE?"}}')